import Styles from "./courses.module.css";
import { Headline, Image, Attribute, ProHeadline } from "../../subcomponents/subcomponents";
export const Courses       = ( props ) => {
    const { courses = [], filter } = props;
    const { Courses } = Styles;
    return (
        <main className={ Courses }>
            {
                courses.map(( value, key ) => {
                    const { image, imageTheme, clipsNumber, clipsTime, cost, name, nameTheme, link, category } = value;
                    return filter === "All" ? 
                        <Course 
                            image       = { image       }
                            imageTheme  = { imageTheme  }
                            clipsNumber = { clipsNumber }
                            cost        = { cost        }
                            clipsTime   = { clipsTime   }
                            name        = { name        }
                            nameTheme   = { nameTheme   }
                            link        = { link        }
                            key         = { key         }
                        /> :
                        filter === category && 
                        <Course 
                            image       = { image       }
                            imageTheme  = { imageTheme  }
                            clipsNumber = { clipsNumber }
                            cost        = { cost        }
                            clipsTime   = { clipsTime   }
                            name        = { name        }
                            nameTheme   = { nameTheme   }
                            link        = { link        }
                            key         = { key         }
                        />;
                })
            }
        </main>
    );
};
export const CoursesHeader = ( props ) => {
    const { setFilter, headlines = [] } = props;
    const { CoursesHeader } = Styles;
    const Attributes = [
        { 
            icon    : <i className="bi bi-globe"></i>, 
            span    : <span></span>, 
            text    : "All", 
            onClick : (e) => setFilter("All") 
        },
        { 
            icon    : <i className="bi bi-terminal-fill" style={{ color: "#9c27b0" }}></i>, 
            span    : <span style={{ backgroundColor: "#9c27b0" }}></span>, 
            text    : "Programming", 
            color   : "#9c27b0", 
            onClick : (e) => setFilter("programming") 
        },
        { 
            icon    : <i className="bi bi-grid-fill" style={{ color: "#3f51b5" }}></i>, 
            span    : <span style={{ backgroundColor: "#3f51b5" }}></span>, 
            text    : "Apps", 
            color   : "#3f51b5", 
            onClick : (e) => setFilter("apps") 
        },
        { 
            icon    : <i className="bi bi-person-video3" style={{ color: "#009688" }}></i>, 
            span    : <span style={{ backgroundColor: "#009688" }}></span>, 
            text    : "Courses", 
            color   : "#009688", 
            onClick : (e) => setFilter("courses") 
        },
    ];
    return (
        <header className={ CoursesHeader }>
            <Attribute   Attributes = { Attributes }/>
            <ProHeadline headlines  = { headlines  }/>
        </header>
    );
};
const Course               = ( props ) => {
    const { image, imageTheme, clipsNumber, clipsTime, cost, name, nameTheme, link } = props;
    const { Course } = Styles;
    const Attributes = [
        { 
            icon : <i className="bi bi-collection-play-fill"></i>, 
            span : <span></span>, 
            text : clipsNumber 
        },
        { 
            icon : <i className="bi bi-clock-fill"></i>, 
            span : <span></span>, 
            text : clipsTime 
        },
        { 
            text       : cost, 
            fontFamily : "BRLNSDB", 
            color      : "#4caf50" 
        },
        { 
            icon : <i className="bi bi-folder-symlink-fill" style={{ color: "cyan" }}></i>, 
            span : <span style={{ display: "none" }}></span>,
            link : link,
        },
    ];    
    return (
        <div className={ Course }>
            <Image
                src   = { image      }
                theme = { imageTheme }
                link  = { link       }
            />
            <Attribute
                Attributes = { Attributes } 
                width      = { 400        }
            />
            <Headline
                icon  = { <i className="bi bi-play-btn-fill"></i> } 
                text  = { name                                    }
                width = { 400                                     }
                theme = { nameTheme                               }
                link  = { link                                    }
            />
        </div>
    );
}; 